import React, { useState, useEffect } from 'react';
import { Button } from 'react-bootstrap';
import { jwtDecode } from 'jwt-decode';

export const Associations = ({ associationsEndpoint }) => {
  const [associations, setAssociations] = useState([]);
  const [formattedAssociations, setFormattedAssociations] = useState("");
  const [toggleAssociations, setToggleAssociations] = useState(false);
  const storedToken = localStorage.getItem('token');
  const associationsShown = 2;
  // Format associations from an array of objects to a displayable string
  const formatAssociations = (associationArray) => {
    return associationArray.map(association => {
      if (association.isDefault) {
        return `<span><b>${association.label}</b></span>`;
      } else {
        return association.label;
      }
    }).join('|');
  };

  const showAssociations = () => {
    setToggleAssociations(!toggleAssociations);
  };

  const parseAssociations = (data, maxDisplay) => {
    const displayedAssociations = data.slice(0, maxDisplay);
    const formatted = formatAssociations(displayedAssociations);
    if (data.length > maxDisplay) {
      setFormattedAssociations(`${formatted}|An additional ${data.length - maxDisplay} not shown`);
    } else {
      setFormattedAssociations(formatted);
    }
  };

  const showSomeAssociations = () => {
    parseAssociations(associations, associationsShown);
  };

  const showAllAssociations = async () => {
    try {
      setFormattedAssociations("Loading...");
      const identity = jwtDecode(storedToken);
      const response = await fetch(`${associationsEndpoint}${identity.sub}`, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${storedToken}`,
          'Content-Type': 'application/json'
        }
      });
      if (response.ok) {
        const data = await response.json();
        setAssociations(data);
        parseAssociations(data, 1000);
      } else {
        showSomeAssociations();
        console.error('Failed to fetch associations');
      }
    } catch (error) {
      showSomeAssociations();
      console.error('Failed to fetch associations', error);
    }
  };

  const getInitialAssociation = async () => {
    const identity = jwtDecode(storedToken);
    try {
      const response = await fetch(`${associationsEndpoint}${identity.sub}`, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${storedToken}`,
          'Content-Type': 'application/json'
        }
      });
      if (response.ok) {
        const data = await response.json();
        setAssociations(data);
        parseAssociations(data, associationsShown);
      } else {
        console.log('error', response);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getInitialAssociation();
  }, []);

  useEffect(() => {
    if (toggleAssociations) {
      showAllAssociations();
    } else {
      showSomeAssociations();
    }
  }, [toggleAssociations]);

  return (
    <>
    <div className='associationContainer'>
      <div className='d-flex'>
        <div className='card-bold'>Account Associations</div>
        <div>
          {associations.length > associationsShown && (
            <Button className='e-link' onClick={showAssociations}>
              {toggleAssociations ? 'Show less' : `+ ${associations.length - associationsShown} more`}
            </Button>
          )}
        </div>
      </div>
      <ul className=''>
        {formattedAssociations ? (
          formattedAssociations.split('|').map((association, index) => (
            <li key={index} dangerouslySetInnerHTML={{ __html: association }}></li>
          ))
        ) : (
          'No Associations'
        )}
      </ul>
    </div>
    </>
  );
};
